<template>
  <div>
    <div class="c-box">
      <img src="../../../assets/app/blank.png" alt="">
      <div class="title">{{value.title}}</div>
      <div class="subTitle">{{value.subTitle}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // 传进来的标题值
    value: {
      type: Object,
      default: {
        title: '本日本区暂无',
        subTitle: '99套餐业务发展，要加油哦!',
      }
    }
  },

}

</script>
<style lang="less" scoped>
.c-box {
  font-family: 'PingFang-SC-Medium';
  width: 100%;
  margin-top: 55%;
  text-align: center;
  img {
    width: 4rem;
  }
  .title {
    font-size: 0.3rem;
    color: #43484D;
  }
  .subTitle {
    margin-top: 0.2rem;
    font-size: 0.3rem;
    color: #43484D;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/app/common/noMessage.vue